
































import sitesApi from '@/api/sites.api';
import {
    SiteStatus,
    translateSiteStatus,
    ISite,
    IConfirm,
    ISort,
    IPaging,
    ISearchBody,
    withPaging
} from '@/entities';
import store from '@/store/store';
import * as types from '@/store/types';

import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';

import Component from 'vue-class-component';

@Component({})
export default class AgentOfficeSitesMasterPage extends MasterPageCriteria {

    public items: ISite[] = [];

    protected defaultSort: ISort = {
        field: 'hostname',
        asc: true
    };

    get agentId(): number {
        return Number.parseInt(this.$route.params.agentId, 10);
    }

    get officeId(): number {
        return Number.parseInt(this.$route.params.officeId, 10);
    }

    get name(): string {
        return decodeURIComponent(this.$route.params.name);
    }


    public created() {
        this.search();
    }

    public async list(body: ISearchBody): Promise<IPaging<ISite>> {
        if (this.agentId) {
            const items = await sitesApi.listAgentSites(this.agentId);
            return withPaging(items);
        } else if (this.officeId) {
            const items = await sitesApi.listCompanySites(this.officeId);
            return withPaging(items);
        }
    }
}
